"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkpErrorHandler = exports.errorHandler = void 0;
var errorHandler = function (error) { var _a; return ({ error: ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || error }); };
exports.errorHandler = errorHandler;
var mkpErrorHandler = function (error) { return ({ error: error, data: undefined }); };
exports.mkpErrorHandler = mkpErrorHandler;
